const getProctorMatrix = isMobile => ({
  thGuestSelectorTst: {
    value: 1
  },
  epHpDoneSearchTst: {
    value: +isMobile
  },
  gtTaRecentTst: {
    value: 1
  }
});

module.exports = getProctorMatrix;



// WEBPACK FOOTER //
// ./src/universal/utils/proctor.js